import { getRolesGQLQuery } from '../../graphql/index.js';
export class RolesClient {
    constructor(client) {
        this.client = client;
    }
    async list(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: getRolesGQLQuery(fields),
            variables,
            customToken: accessToken,
        });
        return result.roles;
    }
}
//# sourceMappingURL=roles.client.js.map